import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../../routes/Routes.js';

export default function Systeminfo() {
    return (
        <>
            <span className="dropdown-item">
                <Link to={ROUTES.SYSTEMINFO} style={{textDecoration:"none", color:"inherit"}}><i className="bi bi-info-circle me-2"></i>Acerca de</Link>
            </span>
        </>
    );
}